module.exports = '<svg width="32" height="32" viewBox="0 0 32 32"><path d="M16 0C7.164 0 0 7.164 0 16s7.164 16 16 16 16-7.164 16-16S24.836 0 16 0zm8 17.002c0 .552-.452.998-1.004.998h-8.022l2.682 2.838a1.046 1.046 0 0 1 0 1.432l-1.368 1.434a.933.933 0 0 1-1.368 0l-6.642-6.96a1.053 1.053 0 0 1 0-1.434l6.7-7.014a.94.94 0 0 1 1.368 0l1.368 1.434a1.046 1.046 0 0 1 0 1.432L15.028 14h7.968c.552 0 1.004.45 1.004 1.002v2z"/></svg>'


//////////////////
// WEBPACK FOOTER
// ./~/li-icons/dist/js/left-circle-4.js
// module id = 1223
// module chunks = 14